import { all, fork } from "redux-saga/effects";

import LayoutSaga from "./layout/saga";

import calendarSaga from "./calendar/saga";

import ecommerceSaga from "./ecommerce/saga";

import accountSaga from "./auth/register/saga";
import ProfileSaga from "./auth/profile/saga";
import authSaga from "./auth/login/saga";

import reportingSaga from "./reporting/saga";
import reportingInventorySaga from "./reportingInventory/saga";
import escalationSaga from "./escalation/saga";
import meterSaga from "./meter/saga";
import materiovigilanceSaga from "./materiovigilance/saga";
import activeContextSaga from "./activeContext/saga";
import teamSaga from "./team/saga";
import timeEntrySaga from "./timeEntry/saga";
import workOrderCostSaga from "./workOrderCost/saga";
import assetCostSaga from "./assetCost/saga";
import assetTCOSaga from "./assetTCO/saga";

export default function* rootSaga() {
  yield all([
    //public
    fork(LayoutSaga),
    fork(calendarSaga),
    fork(accountSaga),
    fork(ProfileSaga),
    fork(authSaga),
    fork(ecommerceSaga),
    fork(reportingSaga),
    fork(reportingInventorySaga),
    fork(escalationSaga),
    fork(meterSaga),
    fork(materiovigilanceSaga),
    fork(activeContextSaga),
    fork(teamSaga),
    fork(timeEntrySaga),
    fork(workOrderCostSaga),
    fork(assetCostSaga),
    fork(assetTCOSaga),
  ]);
}
